import React, { useEffect, useRef } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import './NotificationModal.css';

const NotificationModal = ({ isOpen, onClose }) => {
  const { notifications, formatTimeAgo, markNotificationsAsViewed, reloadNotifications, clearStorageHistory } = useNotifications();
  const contentRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      markNotificationsAsViewed();
      if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
    }
  }, [isOpen, markNotificationsAsViewed]);

  if (!isOpen) return null;

  return (
    <div className="notification-modal-overlay">
      <div className="notification-modal">
        <div className="notification-modal-header">
          <h3>Notifications ({notifications.length})</h3>
          <div style={{ display: 'flex', gap: '0.5vw', alignItems: 'center' }}>
            <button 
              style={{ 
                background: 'rgba(255,255,255,0.2)', 
                border: 'none', 
                borderRadius: '0.3vw', 
                color: '#fff', 
                padding: '0.3vw 0.6vw',
                fontSize: '0.8vw',
                cursor: 'pointer'
              }}
              onClick={() => {
                clearStorageHistory();
                reloadNotifications();
              }}
              title="Reload notifications"
            >
              🔄
            </button>
            <button 
              className="notification-modal-close"
              onClick={onClose}
            >
              ✕
            </button>
          </div>
        </div>
        <div className="notification-modal-content" ref={contentRef}>
          {notifications.length === 0 ? (
            <div className="no-notifications">
              No notifications yet
            </div>
          ) : (
            <div className="notifications-list">
              {notifications.map((notification) => (
                <div key={notification.id} className={`notification-item ${notification.type}`}>
                  <div className="notification-header">
                    <span className="notification-title">{notification.title}</span>
                    <span className="notification-time">{formatTimeAgo(notification.timestamp)}</span>
                  </div>
                  <div className="notification-message">
                    {notification.message}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
